import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import Validator from '@shared/validatorjs/src/validator'
import { Map } from 'immutable'
import { Subscription } from 'rxjs'
import FormTrait from 'src/app/traits/form.trait'
import {
  FetchBusinessCategoryRequest,
  SetDefaultData,
  UpdateField,
  UpdateBusinessCategoryRequest,
} from '../business-categories.actions'
import { getUpdateBusinessCategoryState } from '../business-categories.selectors'
import { getLicenseTypesState } from '@shared/shared.select'
import { FetchLicenseTypesRequest } from '@shared/shared.actions'

@Component({
  selector: 'app-update-business-category',
  templateUrl: './update-business-category.component.html',
  styleUrls: ['./update-business-category.component.css'],
})
export class UpdateBusinessCategoryComponent
  extends FormTrait
  implements OnInit
{
  private state$: Subscription
  private licenseTypes$: Subscription
  public isLoading: boolean
  public licenseTypes = []
  public cid: number

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new FetchLicenseTypesRequest())
    this.cid = parseInt(this.route.snapshot.paramMap.get('id'), 10)
    this.store.dispatch<any>(new SetDefaultData('updateBusinessCategory'))
    this.state$ = this.store
      .pipe(select(getUpdateBusinessCategoryState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')

        if (state.get('shouldReload')) {
          this.store.dispatch<any>(new FetchBusinessCategoryRequest(this.cid))
        }
      })

    this.licenseTypes$ = this.store
      .pipe(select(getLicenseTypesState))
      .subscribe((state) => {
        this.licenseTypes = state.toJS()
      })

    this.store.dispatch<any>(new FetchBusinessCategoryRequest(this.cid))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.licenseTypes$.unsubscribe()
  }

  public handleFieldChange(
    e: any,
    name: null | string = null,
    row: null | number = null,
  ): void {
    if (row !== null) {
      this.store.dispatch(
        new UpdateField(
          name || e.target.name,
          name
            ? e
            : isNaN(e.target.value)
            ? e.target.value
            : parseFloat(e.target.value),
          `updateBusinessCategory.data.subIndustryList.${row}`,
        ),
      )
    } else {
      this.store.dispatch(
        new UpdateField(
          name || e.target.name,
          name ? e : e.target.value,
          'updateBusinessCategory.data',
        ),
      )

      this.store.dispatch(
        new UpdateField(
          'validationErrors',
          this.state.get('validationErrors').delete(name || e.target.name),
          'updateBusinessCategory',
        ),
      )
    }
  }

  public rowDelete(row: number) {
    const list = this.state.getIn(['data', 'subIndustryList']) as any

    this.store.dispatch(
      new UpdateField(
        'subIndustryList',
        list.delete(row).toJS(),
        `updateBusinessCategory.data`,
      ),
    )
  }

  public rowAdd() {
    const list = this.state.getIn(['data', 'subIndustryList']) as any

    this.store.dispatch(
      new UpdateField(
        'subIndustryList',
        list.push({ name: '' }).toJS(),
        `updateBusinessCategory.data`,
      ),
    )
  }

  private validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
      licenseTypeId: 'required|numeric',
    }
    const validator = new Validator(
      {
        name: data.get('name'),
        licenseTypeId: data.get('licenseTypeId'),
      },
      rules,
    )

    validator.setAttributeNames({
      licenseTypeId: 'license type',
    })

    return validator
  }

  public onSubmit(e: Event, redirect = true): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new UpdateBusinessCategoryRequest(this.cid, {
          ...payload,
          penaltyPercentage: parseFloat(payload.penaltyPercentage),
          redirect,
        }),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'updateBusinessCategory',
        ),
      )
    }
  }
}
